export default __webpack_public_path__ + "static/media/illustrated_steps_arrow_down.89adc953.svg";